<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="max-w-1xl mx-auto bg-white p-4 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Manage Therapy Packs Subscription</h1>
  </div>
  <div
    class="flex items-start gap-4"
    style="background: #ececec; padding: 30px"
  >
    <nz-card
      [nzLoading]="pageLoading"
      *ngIf="tableData.length && isUserPage"
      style="width: 400px"
      [nzBordered]="false"
      nzTitle="User info"
    >
      <p>User Name : {{ tableData[0].userDetails.name }}</p>
      <p>User Email : {{ tableData[0].userDetails.email }}</p>
      <p>Gender: {{ tableData[0].userDetails.gender }}</p>
      <p>phone: {{ tableData[0].userDetails.phoneNumber }}</p>
      <p>partnerId: {{ tableData[0].userDetails.partnerId }}</p>
      <div class="flex gap-1 flex-wrap">
        tags:
        <nz-tag
          *ngFor="let tag of tableData[0].userDetails.tags"
          [nzColor]="'red'"
          >{{ tag }}</nz-tag
        >
      </div>
    </nz-card>
    <div class="flex flex-col space-y-3 w-full">
      <nz-card
        id="top-container"
        class="animate-bounce-custom w-full"
        [nzBordered]="false"
        nzTitle="Primary Therapist for Selected pack"
        *ngIf="selectedSubscription"
      >
        <p>
          Therapist Name :
          {{ selectedSubscription.primaryTherapistDetails.name }}
        </p>
        <p>
          Therapist Email :
          {{ selectedSubscription.primaryTherapistDetails.email }}
        </p>
      </nz-card>
      <nz-card
        class="overflow-y-auto"
        [nzBordered]="false"
        nzTitle="Auxiliary Therapists for Selected Pack"
        *ngIf="selectedSubscription?.auxiliaryTherapistDetails?.length"
      >
        <div
          *ngFor="
            let therapist of selectedSubscription?.auxiliaryTherapistDetails
          "
          class=""
        >
          <p>Therapist Name: {{ therapist.name }}</p>
          <p>Therapist Email: {{ therapist.email }}</p>
        </div>
      </nz-card>
    </div>
  </div>

  <div class="flex flex-wrap items-center gap-4 p-1">
    <nz-input-group
      nzSearch
      nzSize="large"
      class="w-[360px]"
      [nzAddOnAfter]="globalSearchButton"
    >
      <input
        type="text"
        nz-input
        [(ngModel)]="globalSearchInput"
        (keyup.enter)="searchGlobal()"
        placeholder="Search by subscription id, user name or email"
      />
    </nz-input-group>
    <ng-template #globalSearchButton>
      <button
        nz-button
        nzType="primary"
        nzSize="small"
        nzSearch
        (click)="searchGlobal()"
      >
        Search
      </button>
    </ng-template>
  </div>

  <nz-spin [nzSpinning]="tableLoading">
    <nz-table
      #nestedTable
      [nzTitle]="tableHead"
      [nzScroll]="{ x: '700px', y: '500px' }"
      [nzData]="tableData"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalRecords"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="page"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th nzWidth="40px"></th>
          <th *ngIf="isUserPage" nzWidth="120px">Plan Name</th>
          <th *ngIf="!isUserPage" nzWidth="120px">User Name</th>
          <th>
            Purchased date
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="purchasedAtDateFilterMenu"
            >
              <span nz-icon nzTheme="outline" nzType="schedule"></span>
            </nz-filter-trigger>
          </th>
          <th>
            Validity
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="validTillDateFilterMenu"
            >
              <span nz-icon nzTheme="outline" nzType="schedule"></span>
            </nz-filter-trigger>
          </th>
          <th nzWidth="100px">
            Payment Type
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="paymentTypeMenu"
            >
              <span nz-icon nzTheme="outline" nzType="filter-o"></span>
            </nz-filter-trigger>
          </th>
          <th>Primary Concern</th>
          <th>Auxiliary Concern</th>
          <th>
            Completed primary session / Total primary session | Completed
            auxiliary session / Total auxiliary session
          </th>
          <th nzWidth="80px">Pack value</th>
          <th nzWidth="100px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of nestedTable.data">
          <tr>
            <td
              (nzExpandChange)="
                onExpandChange(data.packSubscriptionId, $event, data)
              "
              [nzExpand]="expandSet.has(data.packId)"
            ></td>
            <td *ngIf="isUserPage">{{ data.packName }}</td>
            <td *ngIf="!isUserPage">{{ data.userDetails.name }}</td>
            <td>
              {{ utils.convertEpochToFormattedDate(data.activedOn.toString()) }}
            </td>
            <td>
              {{ utils.convertEpochToFormattedDate(data.validTill.toString()) }}
              <nz-tag *ngIf="data.deactivatedOn != 'N/A'" nzColor="red"
                >DEACTIVATED</nz-tag
              >
            </td>
            <td [align]="'left'">
              <nz-tag [nzColor]="'green'">{{
                utils.convertToTitleCase(data.paymentType)
              }}</nz-tag>
            </td>
            <td>
              <nz-tag [nzColor]="'blue'">
                {{ getConcernNameById(data.primaryConcern) }}
              </nz-tag>
            </td>

            <td>
              <ng-container *ngFor="let concern of data.auxiliaryConcern">
                <nz-tag [nzColor]="'green'">{{
                  getConcernNameById(concern)
                }}</nz-tag>
              </ng-container>
            </td>
            <td>
              <nz-tag [nzColor]="'green'">{{
                data.completedPrimarySession +
                  "/" +
                  data.numberOfPrimarySessions
              }}</nz-tag>
              &vert;
              <nz-tag [nzColor]="'red'">{{
                data.completedAuxiliarySession +
                  "/" +
                  data.numberOfAuxiliarySessions
              }}</nz-tag>
            </td>

            <td>{{ "₹ " + data.totalPackValue }}</td>
            <td class="flex items-center gap-2">
              <!-- Change Assigned Therapist Button -->
              <button
                nz-button
                nzType="dashed"
                nzSize="small"
                nzShape="circle"
                nz-tooltip="Transfer Therapist"
                (click)="onChangeTherapist(data)"
                class="flex items-center justify-center"
              >
                <i nz-icon nzType="user-switch" nzTheme="outline"></i>
              </button>

              <!-- Send Feedbacks To Therapist Button -->
              <button
                *ngIf="showSendFeedbackBtn"
                nz-button
                nzType="dashed"
                nzSize="small"
                nzShape="circle"
                nz-tooltip="Send feedbacks to therapist"
                (click)="onSendFeedback(data)"
                class="flex items-center justify-center"
              >
                <i nz-icon nzType="file-excel" nzTheme="outline"></i>
              </button>

              <!-- Update Therapist Button -->
              <button
                nz-button
                nzType="dashed"
                nzSize="small"
                nzShape="circle"
                nz-tooltip="Update Therapist"
                (click)="onUpdateTherapist(data)"
                class="flex items-center justify-center"
              >
                <i nz-icon nzType="usergroup-delete" nzTheme="outline"></i>
              </button>

              <!-- Deactivate Subscription Button -->
              <button
                nz-button
                nzType="dashed"
                nzSize="small"
                nzShape="circle"
                nz-tooltip="Deactivate Subscription"
                (click)="onCancelSubscription(data.packSubscriptionId)"
                class="flex items-center justify-center"
              >
                <i nz-icon nzType="close-circle" nzTheme="outline"></i>
              </button>
            </td>
          </tr>
          <tr [nzExpand]="expandSet.has(data.packSubscriptionId)">
            <nz-table
              #innerTable
              [nzData]="data.sessionDetails"
              [nzTotal]="data.sessionDetails.length"
              nzSize="middle"
              nzFrontPagination="true"
              [nzPageSize]="10"
              [nzTitle]="innerTableHead"
            >
              <thead>
                <tr>
                  <th>Session Type</th>
                  <th>Session Date</th>
                  <th>Session Name</th>
                  <th>Session Description</th>
                  <th>Session Booked</th>
                  <th>Session Completed</th>
                  <th>Session Status</th>
                  <th>Is Extra Session</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of innerTable.data">
                  <td>
                    <nz-tag
                      [nzColor]="
                        data.primaryTherapist || !data.secondaryTherapist
                          ? 'green'
                          : 'red'
                      "
                      >{{
                        data.primaryTherapist || !data.secondaryTherapist
                          ? "Primary Session"
                          : "Secondary Session"
                      }}</nz-tag
                    >
                  </td>
                  <td>
                    {{
                      data.sessionDate
                        ? convertDataAndTime(data.sessionDate)
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{ data.sessionName }}
                  </td>
                  <td>{{ data.description }}</td>
                  <td>{{ data.sessionBooked ? "Yes" : "No" }}</td>
                  <td>{{ data.sessionCompleted ? "Yes" : "No" }}</td>
                  <td>{{ data.sessionStatus }}</td>
                  <td>{{ data.extraSession ? "Yes" : "No" }}</td>
                </tr>
              </tbody>
            </nz-table>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span *ngIf="tableData.length" class="font-bold"
        >Therapy Packs Subscription for {{ isUserPage ? "User" : "Pack" }} -
        {{
          isUserPage ? tableData[0].userDetails.name : tableData[0].packName
        }}</span
      >
      <span *ngIf="!tableData.length" class="font-bold"
        >Therapy Packs Subscription for {{ isUserPage ? "User" : "" }}</span
      >
    </div>
    <div class="flex gap-2">
      <div nz-col>
        <nz-switch
          (ngModelChange)="testEventChangeFn($event)"
          [(ngModel)]="showTest"
          nzCheckedChildren="Hide Test Packs Subscription"
          nzUnCheckedChildren="Show Test Packs Subscription"
          class="mr-3"
        ></nz-switch>
        <button
          class="btn-color"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Clear filter
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #innerTableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold"
        >Session Details - See on top for therapist Details</span
      >
    </div>
    <div nz-col>
      <button nz-button (click)="scrollToTop()" nzType="primary">
        See Therapist Details
      </button>
    </div>
  </div>
</ng-template>
<nz-dropdown-menu #paymentTypeMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Payment Type</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="paymentTypeFilterChangeFn($event)">
          <div *ngFor="let topic of paymentTypeCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="topic.value"
                [ngModel]="topic.checked"
                >{{ topic.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="fetchPacksSubscription()"
        >
          Ok
        </button>
      </div>

      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #validTillDateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker
        [(ngModel)]="validTillColumnFilterDate"
        (ngModelChange)="validTillFilterDateChange($event)"
      ></nz-range-picker>
    </div>
    <div nz-row class="mt-5" nzJustify="end">
      <div nz-col class="mr-1">
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="fetchPacksSubscription()"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #purchasedAtDateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker
        [(ngModel)]="purchasedAtColumnFilterDate"
        (ngModelChange)="purchasedAtFilterDateChange($event)"
      ></nz-range-picker>
    </div>
    <div nz-row class="mt-5" nzJustify="end">
      <div nz-col class="mr-1">
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="fetchPacksSubscription()"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-modal
  [(nzVisible)]="isModelVisible"
  [nzTitle]="'Confirm Cancellation'"
  [nzFooter]="modalFooter"
  [nzContent]="modalContent"
  (nzOnCancel)="isModelVisible = false"
>
  <ng-template #modalContent>
    <p>Are you sure you want to cancel the subscription?</p>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="isModelVisible = false">
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="handleCancelSubscription()">
      Confirm
    </button>
  </ng-template>
</nz-modal>
<nz-modal
  [(nzVisible)]="isModel2Visible"
  [nzTitle]="'Transfer Therapist'"
  [nzFooter]="modal2Footer"
  [nzContent]="modal2Content"
  (nzOnCancel)="onCloseModel2()"
>
  <ng-template #modal2Content>
    <nz-radio-group
      [(ngModel)]="selectedTherapistType"
      (ngModelChange)="onTherapistTypeChange($event)"
    >
      <label nz-radio nzValue="primary">Primary Therapist</label>
      <label nz-radio nzValue="aux">Aux Therapist</label>
    </nz-radio-group>

    <nz-select
      [(ngModel)]="selectedOption"
      (ngModelChange)="onSelectedTherapistOptionChange($event)"
      style="width: 100%; margin-top: 10px"
    >
      <nz-option
        *ngFor="let option of therapistOptions"
        [nzLabel]="option.label"
        [nzValue]="option.value"
      ></nz-option>
    </nz-select>

    <div class="mt-3" *ngIf="affectedSessions.length > 0">
      <label
        nz-checkbox
        [(ngModel)]="transferConfirmedSessions"
        (ngModelChange)="onTransferConfirmedPackToggle($event)"
      >
        Also transfer confirmed upcoming sessions
      </label>
    </div>
    <app-session-feedback-selector
      *ngIf="isModel2Visible && pack"
      [sessions]="pack.sessionDetails"
      title="Send a feedback document mail to the new therapist"
      (selectedSessionIdsChange)="feedbackSessionIds = $event"
    ></app-session-feedback-selector>
    <div
      *ngIf="transferConfirmedSessions && affectedSessions.length > 0"
      class="mt-3 p-3"
      style="background: #f7f7f7; border-radius: 6px"
    >
      <p>
        <strong>Sessions to be reassigned:</strong>
        {{ affectedSessions.length }}
      </p>
      <ul>
        <li *ngFor="let s of affectedSessions">
          {{ s.sessionName || "Session" }} —
          {{ convertDataAndTime(s.sessionDate!) }}
        </li>
      </ul>
      <p class="mt-2"><strong>Notifications will be sent to:</strong></p>
      <ul>
        <li>Client: {{ selectedSubscription?.userDetails?.email || "N/A" }}</li>
        <li>
          Original therapist(s):
          <span *ngFor="let s of affectedSessions; let i = index">
            {{ s.therapistEmail || "N/A"
            }}<span *ngIf="i < affectedSessions.length - 1">, </span>
          </span>
        </li>
        <li>New therapist: {{ newTherapistEmail || "N/A" }}</li>
      </ul>

      <div class="mt-3">
        <label class="font-medium mb-1 block">Select Date</label>
        <nz-date-picker
          class="w-full"
          (ngModelChange)="onNewPackSessionDateChange($event)"
          [(ngModel)]="date"
        ></nz-date-picker>
      </div>

      <div
        class="mt-4"
        *ngIf="selectedSessionDate && checkBoxTimeRangeOptions.length === 0"
      >
        <p>No available slots for selected day.</p>
      </div>

      <div class="mt-4" *ngIf="checkBoxTimeRangeOptions.length > 0">
        <label class="font-medium mb-2 block">Available Slots</label>
        <nz-checkbox-wrapper (nzOnChange)="onNewPackSessionTimeChange($event)">
          <div
            *ngFor="let status of checkBoxTimeRangeOptions; let i = index"
            class="mb-1"
          >
            <label
              nz-checkbox
              [nzDisabled]="status.disabled"
              [nzValue]="status.value"
              [(ngModel)]="status.checked"
              (ngModelChange)="onPackCheckboxClick($event, i)"
            >
              {{ status.label }}
            </label>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
  </ng-template>

  <ng-template #modal2Footer>
    <button nz-button nzType="default" (click)="isModel2Visible = false">
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="handleTransferSubscription()"
      [disabled]="
        !selectedOption ||
        (transferConfirmedSessions &&
          affectedSessions.length > 0 &&
          sessionOkDisabled)
      "
    >
      Confirm
    </button>
  </ng-template>
</nz-modal>
<nz-modal
  [(nzVisible)]="isModel3Visible"
  [nzTitle]="'Change Auxiliary Therapist'"
  [nzFooter]="modal3Footer"
  [nzContent]="modal3Content"
  (nzOnCancel)="isModel3Visible = false"
>
  <ng-template #modal3Content>
    <label for="concernSelect" class="block mb-1">Select Concern</label>
    <nz-select
      [(ngModel)]="selectedConcern"
      id="concernSelect"
      style="width: 100%; margin-top: 5px"
      nzPlaceHolder="Select concern"
    >
      <nz-option
        *ngFor="let option of therapistConcernOptions"
        [nzLabel]="option.label"
        [nzValue]="option.value"
      ></nz-option>
    </nz-select>
    <label for="expertiseSelect" class="block mb-1" style="margin-top: 15px"
      >Select Expertise</label
    >
    <nz-select
      [(ngModel)]="selectedExpertise"
      (ngModelChange)="onExpertiseChange($event)"
      id="expertiseSelect"
      style="width: 100%; margin-top: 5px"
      nzPlaceHolder="Select concern"
    >
      <nz-option
        *ngFor="let option of therapistExpertiseOptions"
        [nzLabel]="option.label"
        [nzValue]="option.value"
      ></nz-option>
    </nz-select>
    <label for="therapistSelect" class="block mb-1" style="margin-top: 15px"
      >Select Therapist</label
    >
    <nz-select
      [(ngModel)]="selectedAuxTherapist"
      id="therapistSelect"
      style="width: 100%; margin-top: 5px"
      nzPlaceHolder="Select therapist"
      [disabled]="!selectedExpertise"
    >
      <nz-option
        *ngFor="let option of therapistOptions"
        [nzLabel]="option.label"
        [nzValue]="option.value"
      ></nz-option>
    </nz-select>
  </ng-template>

  <ng-template #modal3Footer>
    <button nz-button nzType="default" (click)="isModel3Visible = false">
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="handleChangeAuxTherapist()"
      [disabled]="!selectedAuxTherapist && !selectedExpertise"
    >
      Confirm
    </button>
  </ng-template>
</nz-modal>
<nz-modal
  [(nzVisible)]="isWarningModalVisible"
  [nzTitle]="'Warning'"
  [nzFooter]="warningModalFooter"
  [nzContent]="warningModalContent"
  (nzOnCancel)="isWarningModalVisible = false"
>
  <ng-template #warningModalContent>
    <p>
      If you continue without selecting "Also transfer confirmed sessions", only
      Open and Pending sessions will move to the new therapist. Confirmed
      sessions will remain with the current therapist and cannot be transferred
      later.
    </p>
  </ng-template>

  <ng-template #warningModalFooter>
    <button nz-button nzType="default" (click)="handleWarningModalBack()">
      Back
    </button>
    <button nz-button nzType="primary" (click)="handleWarningModalConfirm()">
      Confirm
    </button>
  </ng-template>
</nz-modal>
<app-send-feedback-document-modal
  [(visible)]="isVisibleSendFeedback"
  [sessions]="sendFeedbackPack?.sessionDetails || []"
  [therapistOptions]="sendFeedbackTherapistOptions"
  [defaultTherapistId]="sendFeedbackDefaultTherapistId"
></app-send-feedback-document-modal>
